import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

function LegalLayout({ title, updated, intro, children }) {
  return (
    <main className="bg-slate-50">
      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8">
        <span className="text-xs font-bold uppercase tracking-widest text-emerald-800">Dinverolario</span>
        <h1 className="mt-3 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">{title}</h1>
        <p className="mt-2 text-sm text-slate-500">{updated}</p>
        <p className="mt-6 text-base leading-relaxed text-slate-700">{intro}</p>
        <div className="mt-10 space-y-6">{children}</div>
      </div>
    </main>
  );
}

export function PrivacyPage() {
  const { t } = useI18n();
  const sections = t("privacy.sections") || [];
  return (
    <LegalLayout
      title={t("privacy.title")}
      updated={t("privacy.updated")}
      intro={t("privacy.intro")}
    >
      {sections.map((s, i) => (
        <section key={i} data-testid={`privacy-section-${i}`} className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
          <h2 className="text-lg font-semibold text-slate-900">{s.title}</h2>
          <p className="mt-2 text-sm leading-relaxed text-slate-700">{s.body}</p>
        </section>
      ))}
    </LegalLayout>
  );
}

export function CookiesPage() {
  const { t } = useI18n();
  const rows = t("cookies.rows") || [];
  const th = t("cookies.tableHeaders") || {};
  return (
    <LegalLayout title={t("cookies.title")} updated={t("cookies.updated")} intro={t("cookies.intro")}>
      <section className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
        <h2 className="text-lg font-semibold text-slate-900">{t("cookies.consentTitle")}</h2>
        <p className="mt-2 text-sm leading-relaxed text-slate-700">{t("cookies.consentText")}</p>
      </section>
      <section className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-slate-200 text-left text-sm">
            <thead className="bg-slate-100 text-xs font-semibold uppercase tracking-wider text-slate-600">
              <tr>
                <th className="px-3 py-2">{th.name}</th>
                <th className="px-3 py-2">{th.purpose}</th>
                <th className="px-3 py-2">{th.duration}</th>
                <th className="px-3 py-2">{th.category}</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 text-slate-700">
              {rows.map((r, i) => (
                <tr key={i} data-testid={`cookie-row-${i}`}>
                  <td className="px-3 py-2 font-mono text-xs">{r.name}</td>
                  <td className="px-3 py-2">{r.purpose}</td>
                  <td className="px-3 py-2">{r.duration}</td>
                  <td className="px-3 py-2">{r.category}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
      <section className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
        <h2 className="text-lg font-semibold text-slate-900">{t("cookies.manageTitle")}</h2>
        <p className="mt-2 text-sm leading-relaxed text-slate-700">{t("cookies.manageText")}</p>
      </section>
    </LegalLayout>
  );
}

export function TermsPage() {
  const { t } = useI18n();
  const sections = t("terms.sections") || [];
  return (
    <LegalLayout title={t("terms.title")} updated={t("terms.updated")} intro={t("terms.intro")}>
      {sections.map((s, i) => (
        <section key={i} data-testid={`terms-section-${i}`} className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
          <h2 className="text-lg font-semibold text-slate-900">{s.title}</h2>
          <p className="mt-2 text-sm leading-relaxed text-slate-700">{s.body}</p>
        </section>
      ))}
    </LegalLayout>
  );
}
